import React from 'react'

import { PriceBoxListContainerStyled, PriceBoxListStyled, PriceBoxListItemStyled } from './styles'
import PriceBox from './../../molecules/PriceBox'
import { PriceBoxListProps } from './types'

const PriceBoxList: React.FC<PriceBoxListProps> = ({ data }) => {
  return (
    <PriceBoxListContainerStyled>
      <PriceBoxListStyled isBig={data.length > 3 ? true : false} as="ul">
        {data.map((el) => (
          <PriceBoxListItemStyled as="li">
            <PriceBox isSmall={data.length > 3 ? true : false} data={el} />
          </PriceBoxListItemStyled>
        ))}
      </PriceBoxListStyled>
    </PriceBoxListContainerStyled>
  )
}

export default PriceBoxList
